import { render, staticRenderFns } from "./DevStatistics.vue?vue&type=template&id=0b596de9&scoped=true"
import script from "./DevStatistics.vue?vue&type=script&lang=js"
export * from "./DevStatistics.vue?vue&type=script&lang=js"
import style0 from "./DevStatistics.vue?vue&type=style&index=0&id=0b596de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b596de9",
  null
  
)

export default component.exports